import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmMappingValidFormDataSchema.translations.json';
import { z } from 'zod/v3';
import { errorMap, zCodeWithoutLeadingNumber } from '../../../../common/utils';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-mappings-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmMappingValidFormDataSchema = z.object({
  id: z.number().optional(),
  classifierMapping: z
    .string(errorMap(() => t('validation.classifierMapping.required')))
    .min(1),
  classifierToCode: z.string().optional(),
  sourceDimension: z
    .string(errorMap(() => t('validation.sourceDimension.required')))
    .min(1),
  alias: zCodeWithoutLeadingNumber(),
  joinTypeCode: z
    .string(errorMap(() => t('validation.joinTypeCode.required')))
    .min(1),
});
